import script from "./VirtualTerminal.vue?vue&type=script&setup=true&lang=js"
export * from "./VirtualTerminal.vue?vue&type=script&setup=true&lang=js"

import "./VirtualTerminal.vue?vue&type=style&index=0&id=05459634&lang=scss"

const __exports__ = script;

export default __exports__